// custom-native-date-adapter.service.ts
import { Injectable, Inject } from '@angular/core';
import { NativeDateAdapter, DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';


export const CUSTOM_DATE_FORMATS = {
    parse: {
        dateInput: 'LL',
    },
    display: {
        dateInput: 'LL',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@Injectable()
export class CustomNativeDateAdapter extends NativeDateAdapter {
    constructor(
        private translateService: TranslateService,
        @Inject(MAT_DATE_LOCALE) locale: string
    ) {
        super(locale);

        this.translateService.onLangChange.subscribe(lang => {
            this.setLocale(lang.lang);
        });

        this.setLocale(this.translateService.currentLang || 'fr');
    }

    override format(date: Date, displayFormat: any): string {
        if (!this.isValid(date)) {
            return '';
        }

        if (displayFormat === 'mediumDate' || displayFormat === 'LL') {
            const dtf = new Intl.DateTimeFormat(this.locale, {
                day: 'numeric',
                month: 'short',
                year: 'numeric'
            });
            return dtf.format(date);
        }

        return super.format(date, displayFormat);
    }
    /**
     * Parse a user-provided value into a Date, supporting locale-specific formats.
     * For 'fr' locale, expects 'dd/MM/yyyy'.
     */
    override parse(value: any, parseFormat?: any): Date | null {
        if (typeof value === 'string' && value.trim().length > 0) {
            const str = value.trim();
            // Handle slash-separated numeric dates (dd/MM/yyyy or MM/dd/yyyy)
            const parts = str.split('/');
            if (parts.length === 3) {
                // Determine whether day comes first based on locale (e.g. 'fr')
                const dayFirst = this.locale?.toLowerCase().startsWith('fr');
                const day = Number(dayFirst ? parts[0] : parts[1]);
                const month = Number(dayFirst ? parts[1] : parts[0]) - 1;
                const year = Number(parts[2]);
                if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
                    return new Date(year, month, day);
                }
            }
        }
        // Fallback to default parsing (ISO or JS Date.parse)
        return super.parse(value, parseFormat);
    }
}
